import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import styled, { withTheme } from "styled-components";
import SickDayIcon from "../../../../assets/svg/sick-day-icon.svg";
import MissedSchoolIcon from "../../../../assets/svg/missed-school-icon.svg";
import PaperRecaptureIcon from "../../../../assets/svg/paper-recapture-icon.svg";
import RecallIcon from "../../../../assets/svg/24h-recall-icon.svg";

const OverlayTriggerIcon = styled.i`
  cursor: pointer;
`;

const TooltipWrapper = styled(Tooltip)`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  opacity: 1 !important;

  .tooltip-arrow::before {
    border-right-color: ${(props) => props.theme?.dustyGray};
  }

  .tooltip-inner {
    padding: 9px;
    background-color: ${(props) => props.theme?.white};
    border: 1px solid ${(props) => props.theme?.dustyGray};
    color: ${(props) => props.theme?.nero};

    display: flex;
    flex-direction: column;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;

  img {
    height: 13px;
  }

  span {
    margin-left: 7px;
    text-align: left;
  }

  &:last-child {
    margin-bottom: 0px;
  }
`;

const Icon = styled.i`
  color: #f89400;
`;

const TagsTooltip = (props) => {
  const { showChangeRequestFlag = false } = props;
  const { t } = useTranslation();

  const renderTooltip = (props) => (
    <TooltipWrapper
      id="button-tooltip"
      data-testid="tooltip-wrapper"
      {...props}
    >
      <Item>
        <img src={RecallIcon} />
        <span>{t("appText.dietDiary.24hourRecall")}</span>
      </Item>
      <Item>
        <img src={PaperRecaptureIcon} />
        <span>{t("appText.dietDiary.paperRecapture")}</span>
      </Item>
      <Item>
        <img src={MissedSchoolIcon} />
        <span>{t("appText.dietDiary.missedSchool")}</span>
      </Item>
      <Item>
        <img src={SickDayIcon} />
        <span>{t("appText.dietDiary.sickDay")}</span>
      </Item>
      {showChangeRequestFlag && (
        <Item>
          <Icon className="fas fa-exchange-alt" />
          <span>{"Change request open"}</span>
        </Item>
      )}
    </TooltipWrapper>
  );

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <OverlayTriggerIcon
        className="fas fa-question-circle"
        data-testid="tags-tooltip"
      ></OverlayTriggerIcon>
    </OverlayTrigger>
  );
};

export default withTheme(TagsTooltip);
